import { ConfigEditor } from "./ConfigEditor.js";
import { ExecutionView } from "./ExecutionView.js";
import { Icon } from "./Icon.js";
import { configSchema, dataSchema, defaultConfig } from "./schema.js";
export const automationTaskPlugin = {
    slug: "automation-task",
    name: "Run Automation",
    description: "Execute a background automation task via Cloud Tasks",
    type: "automation",
    completionType: "task_webhook",
    configSchema,
    dataSchema,
    defaultConfig,
    handlers: {
        onStart: (ctx) => {
            ctx.logger.info("Automation started", {
                actionId: ctx.execution.moduleActionId,
                taskType: ctx.config.taskType,
            });
            // In production, this would enqueue a Cloud Task
            return Promise.resolve();
        },
        onWebhook: (_ctx, payload) => {
            const result = payload;
            return Promise.resolve({
                complete: result.success,
                data: {
                    automationResult: result.result,
                    error: result.error,
                },
            });
        },
    },
    components: {
        Icon,
        ConfigEditor,
        ExecutionView,
    },
    order: 3,
    version: "1.0.0",
    author: "Nucleus Team",
};
//# sourceMappingURL=index.js.map